import { render, staticRenderFns } from "./ProductAdvantage.vue?vue&type=template&id=38d9e93c&scoped=true&"
import script from "./ProductAdvantage.vue?vue&type=script&lang=js&"
export * from "./ProductAdvantage.vue?vue&type=script&lang=js&"
import style0 from "./ProductAdvantage.vue?vue&type=style&index=0&id=38d9e93c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d9e93c",
  null
  
)

export default component.exports